import styled from 'styled-components';

export const Container = styled.div`
  opacity: 0;
  visibility: hidden;
  width: 100%;
  height: 0;
`;
